import React, {useEffect, useState} from "react";
import {Link, useLocation} from "react-router-dom";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPlus, faSearch} from "@fortawesome/pro-regular-svg-icons";
import {getStorageItem, parseFilterParamsFromUrl} from "@src/helpers/utils.helper";
import {ProcessFilterRequestType, ProcessType} from "@process/types/process.types";
import {NotFound} from "@src/components";
import {ProcessFilter} from "@process/components";
import {Maybe, PaginationDataType, PaginationType} from "@src/types/global.types";
import {getProcessCollection} from "@process/utils/axios";
import {Col, Row} from "react-bootstrap";
import ProcessTable from "@process/components/ProcessTable/ProcessTable";
import {columnDefinitions, defaultColumns} from "@process/components/ProcessTable/ProcessTable.column";
import {authUser} from "@auth/store/authSlice";
import {useSelector} from "react-redux";
import {UserType} from "@user/types/user.types";

interface ProcessListProps {
}

const createProcessFilter = (locationParams, user: UserType): ProcessFilterRequestType => {
    const storageKey = ('process.filter.' + user.id ?? '').replace(/^\.+|\.+$/g, '');
    let requestParams = parseFilterParamsFromUrl(locationParams);



    const hasTimestamp = requestParams._ts ?? null;
    delete requestParams._ts;
    let processFilter: ProcessFilterRequestType = requestParams;
    let processFilterStorage = getStorageItem(storageKey);
    const filterIsEmpty = Object.keys(processFilter).length === 0;

    if (!hasTimestamp && filterIsEmpty && processFilterStorage) {
        processFilter = processFilterStorage;
    }
    // console.log('requestParams', processFilterStorage)

    let selectedColumns = processFilter?.column ?? [];
    selectedColumns = selectedColumns.filter(columnReq => {
        return columnDefinitions.findIndex((col) => columnReq === col.id) > -1;
    })

    if (selectedColumns.length === 0) {
        selectedColumns = defaultColumns;
    }

    processFilter.column = selectedColumns;
    processFilterStorage = {...processFilter}
    delete processFilterStorage.page;

    window.localStorage.setItem(storageKey, JSON.stringify(processFilterStorage));

    return processFilter;
}


const ProcessListView: React.FC<ProcessListProps> = () => {
    const locationParams = useLocation().search;
    const [processCollection, setProcessCollection] = useState<ProcessType[]>([]);
    const [pagination, setPagination] = useState<Maybe<PaginationType>>();
    const loginUser: UserType = useSelector(authUser);
    const [processFilter, setProcessFilter] = useState<ProcessFilterRequestType>(createProcessFilter(locationParams, loginUser));
    // const [processFilter, setProcessFilter] = useState<ProcessFilterRequestType>({});
    const [isLoad, setLoad] = useState<boolean>(false);

    const fetchProcessCollection = () => {
        getProcessCollection(processFilter).then((paginationData: PaginationDataType<ProcessType>) => {
            setProcessCollection(paginationData.items);
            setPagination(paginationData.pagination);
        }).finally(() => {
            setLoad(true)
        });
    }

    useEffect(() => {
        const newProcessFilter = createProcessFilter(locationParams, loginUser);
        if (JSON.stringify(newProcessFilter) !== JSON.stringify(processFilter)) {
            setProcessFilter(newProcessFilter);
        }
    }, [locationParams])

    useEffect(() => {
        fetchProcessCollection();
    }, [processFilter]);

    return (
        <div className="view-process-list">
            <div className="page-header">
                <Row className="row g-2 align-items-center">
                    <Col className="col">
                        <div className="page-pretitle">
                            Serwis
                        </div>
                        <h2 className="page-title">
                            Lista procesów serwisowych
                        </h2>
                    </Col>
                    <Col className="col-auto ms-auto">
                        <div className="btn-list">
                            <span className="d-none d-sm-inline-">
                                <a href="#" className="btn btn-1">
                                    <FontAwesomeIcon icon={faSearch} fixedWidth={true}/> Szukaj
                                </a>
                            </span>
                            <Link to="/process/create" className="btn btn-primary">
                                <FontAwesomeIcon icon={faPlus} fixedWidth={true}
                                /> <span className="d-none d-sm-inline">
                                    Dodaj
                                </span>
                            </Link>
                        </div>
                    </Col>
                </Row>
            </div>


            <div className="page-body">
                <div>
                    <ProcessFilter processFilterRequest={processFilter}/>
                    {processCollection.length === 0 && isLoad && (
                        <div className="text-center">
                            <NotFound/>
                        </div>
                    )}

                    {processCollection.length > 0 && (
                        <ProcessTable
                            processCollection={processCollection}
                            processFilter={processFilter}
                            pagination={pagination}
                        />
                    )}
                </div>
            </div>
        </div>
    )
};

export default ProcessListView;
